import { useAuth } from "src/hooks/useAuth";
import Brand from "./BrandOwner";
import Retailer from "./Retailer";
import MobileWallet from "./MobileWallet";

export default function Wallet() {
  const { data } = useAuth();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  if (isMobile) {
    return <MobileWallet />;
  }
  return data.merchant_type === "brand" ? (
    <Brand />
  ) : (
    <Retailer />
  );
}